import { render } from "./Inbox.vue?vue&type=template&id=0b852358"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0b852358"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b852358', script)) {
    api.reload('0b852358', script)
  }
  
  module.hot.accept("./Inbox.vue?vue&type=template&id=0b852358", () => {
    api.rerender('0b852358', render)
  })

}

script.__file = "src/icons/components/filled/Inbox.vue"

export default script